/**
 * Generates a token slug from the token name
 * @param tokenName - The name of the token
 * @returns A URL-friendly slug
 */
export function generateTokenSlug(tokenName: string): string {
  let slug = tokenName.replace(/[^a-zA-Z0-9]+/g, "-").toLowerCase();
  if (slug.endsWith('-')) slug = slug.slice(0, -1);
  
  // Handle cases where the slug is empty (e.g., "████████" becomes "")
  if (!slug) {
    return "obscured";
  }
  
  return slug;
}

/**
 * Generates a token URL for the prices page
 * @param token - Token object with name and mint properties
 * @param baseUrl - Optional base URL (defaults to relative path)
 * @returns The complete token URL
 */
export function generateTokenUrl(token: { name: string; mint: string }, baseUrl?: string): string {
  const tokenSlug = generateTokenSlug(token.name);
  const relativeUrl = `/prices/${encodeURIComponent(tokenSlug)}/${token.mint}/`;
  
  if (baseUrl) {
    // Remove trailing slash from baseUrl if present
    const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    return `${cleanBaseUrl}${relativeUrl}`;
  }
  
  return relativeUrl;
} 